export class FormSubmittedModel {
    "patientId": String;
    "categoryId": Number;
    "userId": Number;
}